module.exports = __webpack_public_path__ + "img/brushes-en-4.f0e7db2.jpg";